import { DialogService, ValidationMessage, ValidationMessageType } from '@sdbn/common';
import { MatDialog } from '@angular/material/dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/common';
import { ContextChange } from '@sdbn/common';
import { AppServerAPI } from '@sdbn/common';
import { ResponseStatus } from '@sdbn/common';
import { LogContainer } from '@sdbn/tmc-common';
import { TerminalContextConstants } from '@sdbn/tmc-common';
import { TerminalVisitorRegistration } from '../widgets/terminal/visitor-registration.model';

export class VisitorRegistrationWithBarcodeController extends AbstractStepController {

  private dialogService: DialogService;

  constructor(
  ) {
    super();
    this.dialogService = WizardServiceLocator.injector.get(DialogService);
  }

  onContextChange(contextChange: ContextChange) {
  }

  onRegisterToDashboardContext() {

  }

  private validateRegistrationCodeAndGetVisitData() {

    const appServerAPI = WizardServiceLocator.injector.get(AppServerAPI);

    this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
    return appServerAPI.execute('/terminal/registration/visitor/barcode', { value: this.dashboardContext.getContextValue('barcodeScanned') })
      .toPromise().then((response: TerminalVisitorRegistration) => {
        this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
        this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
        if (response.status !== ResponseStatus.FAILED) {

          const registration = new TerminalVisitorRegistration(response);

          this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
          this.dashboardContext.setContextValue(TerminalContextConstants.lastname, registration.name);
          this.dashboardContext.setContextValue(TerminalContextConstants.firstname, registration.firstname);
          this.dashboardContext.setContextValue(TerminalContextConstants.company, registration.company);
          this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
          this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
          this.dashboardContext.setContextValue(TerminalContextConstants.reasonForVisit, registration.reason);
          this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, registration.visitedPerson);
          this.dashboardContext.setContextValue('needsAreaAccess', registration.needsAreaAccess);
          this.dashboardContext.setContextValue('entranceBarrierSecuredAreaNeeded', registration.needsAreaAccess);
          this.dashboardContext.setContextValue('visitorType', registration.visitorType);
          this.dashboardContext.setContextValue('inviterId', registration.inviterId);

          if (registration.inYard) {
            const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
            logContainer.addLog('Valid code detected. Visitor in yard. Start leave process');
            this.wizardComponent.handoverToFlow('registration-terminal-visitor-leave');
          } else {
            const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
            logContainer.addLog('Valid code detected. New visitor.');
            this.onOnRegistrationCodeValid();
          }
        } else {
          const validationMessages = new Array<ValidationMessage>();
          for (const responseMessage of response.responseMessages) {
            validationMessages.push(ValidationMessage.createWithData(ValidationMessageType.ERROR, responseMessage.dictionaryKey));
          }
          this.dashboardContext.setContextValue('validationMessages', validationMessages);
          this.dashboardContext.setContextValue('responseMessages', response.responseMessages);
        }
      }, error => {
        // TODO specify what happens for bad codes
      });
  }

  private onOnRegistrationCodeValid() {
    this.wizardComponent.next('visitor-registration-masterdata');
  }


  public handleFlow(): FlowStepHandleResult {
    this.wizardComponent.startInactivityMonitoring();
    const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
    logContainer.addLog('registration code validation started');

    this.validateRegistrationCodeAndGetVisitData();

    const result = new FlowStepHandleResult();
    result.type = HandleResultType.DASHBOARD;
    return result;
  }

  private cancel() {
    this.dialogService.showConfirm('tmc-yard.widgets.registration-terminal.cancel-dialog.title',
      'tmc-yard.widgets.registration-terminal.cancel-dialog.message').afterClosed().subscribe(() => {
        this.wizardComponent.stopInactivityMonitoring();
        this.wizardComponent.restartWizard();
      });
  }

  getControls(): StepControl[] {
    const controls = new Array<StepControl>();

    const previousControl = new StepControl();
    previousControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.previous';
    previousControl.type = StepControlType.BUTTON_STROKED;
    previousControl.iconBeforeCss = 'fa-thin fa-angle-left';
    previousControl.controlAction = () => {
      this.wizardComponent.stopInactivityMonitoring();
      this.wizardComponent.previous();
    };
    controls.push(previousControl);

    let spacer = new StepControl();
    spacer.type = StepControlType.SPACER_GROW;
    controls.push(spacer);

    const cancelControl = new StepControl();
    cancelControl.labelDictionaryKey = 'tmc-yard.common.action.cancel';
    cancelControl.type = StepControlType.BUTTON_STROKED;
    cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
    cancelControl.controlAction = this.cancel.bind(this);
    controls.push(cancelControl);

    spacer = new StepControl();
    spacer.type = StepControlType.SPACER;
    controls.push(spacer);

    const newRegistrationControl = new StepControl();
    newRegistrationControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.button.alternative';
    newRegistrationControl.type = StepControlType.BUTTON_STROKED;
    newRegistrationControl.iconAfterCss = 'fa-thin fa-angle-right';
    newRegistrationControl.controlAction = () => {
      this.wizardComponent.stopInactivityMonitoring();
      this.wizardComponent.next('visitor-registration-masterdata');
    };
    controls.push(newRegistrationControl);

    return controls;
  }
}
